import ContentAndImage from '../Page/ContentAndImage';

export default ContentAndImage;
